var _rect, _path, _path2, _path3, _path4, _path5, _g, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrays(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 31,
    viewBox: "0 0 96 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 19,
    width: 80,
    height: 8,
    fill: "#CCCCCC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21L11 17L2.5 25.5L5 29.5L12 21Z",
    fill: "#B7B7B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84 21L85 17L93.5 25.5L91 29.5L84 21Z",
    fill: "#B7B7B7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17H85L84 21H12L11 17Z",
    fill: "#E0E0E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.23922 27.1961C3.11547 26.5773 3.58876 26 4.2198 26H91.7802C92.4112 26 92.8845 26.5773 92.7608 27.1961L92.1608 30.1961C92.0673 30.6635 91.6569 31 91.1802 31H4.8198C4.34312 31 3.93271 30.6635 3.83922 30.1961L3.23922 27.1961Z",
    fill: "#E0E0E0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4141 16C10.1489 16 9.89454 16.1054 9.70701 16.2929L0.707007 25.2929C0.0770423 25.9229 0.52321 27 1.41411 27H94.5857C95.4766 27 95.9228 25.9229 95.2928 25.2929L86.2928 16.2929C86.1053 16.1054 85.8509 16 85.5857 16H10.4141ZM84.9999 17H10.9999L2.9999 25H92.9999L84.9999 17Z",
    fill: "#A4A4A4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10278_34830)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 15,
    width: 80,
    height: 8,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17L11 13L2.5 21.5L5 25.5L12 17Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 17L85 13L93.5 21.5L91 25.5L84 17Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 13H85L84 17H12L11 13Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.23922 23.1961C3.11547 22.5773 3.58876 22 4.2198 22H91.7802C92.4112 22 92.8845 22.5773 92.7608 23.1961L92.1608 26.1961C92.0673 26.6635 91.6569 27 91.1802 27H4.8198C4.34312 27 3.93271 26.6635 3.83922 26.1961L3.23922 23.1961Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4141 12C10.1489 12 9.89454 12.1054 9.70701 12.2929L0.707007 21.2929C0.0770423 21.9229 0.52321 23 1.41411 23H94.5857C95.4766 23 95.9228 21.9229 95.2928 21.2929L86.2928 12.2929C86.1053 12.1054 85.8509 12 85.5857 12H10.4141ZM84.9999 13H10.9999L2.9999 21H92.9999L84.9999 13Z",
    fill: "#A4A4A4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10278_34830)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 11,
    width: 80,
    height: 8,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13L11 9L2.5 17.5L5 21.5L12 13Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 13L85 9L93.5 17.5L91 21.5L84 13Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 9H85L84 13H12L11 9Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.23922 19.1961C3.11547 18.5773 3.58876 18 4.2198 18H91.7802C92.4112 18 92.8845 18.5773 92.7608 19.1961L92.1608 22.1961C92.0673 22.6635 91.6569 23 91.1802 23H4.8198C4.34312 23 3.93271 22.6635 3.83922 22.1961L3.23922 19.1961Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4141 8C10.1489 8 9.89454 8.10536 9.70701 8.29289L0.707007 17.2929C0.0770423 17.9229 0.52321 19 1.41411 19H94.5857C95.4766 19 95.9228 17.9229 95.2928 17.2929L86.2928 8.29289C86.1053 8.10536 85.8509 8 85.5857 8H10.4141ZM84.9999 9H10.9999L2.9999 17H92.9999L84.9999 9Z",
    fill: "#A4A4A4"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_10278_34830)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 7,
    width: 80,
    height: 8,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9L11 5L2.5 13.5L5 17.5L12 9Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 9L85 5L93.5 13.5L91 17.5L84 9Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 5H85L84 9H12L11 5Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.23922 15.1961C3.11547 14.5773 3.58876 14 4.2198 14H91.7802C92.4112 14 92.8845 14.5773 92.7608 15.1961L92.1608 18.1961C92.0673 18.6635 91.6569 19 91.1802 19H4.8198C4.34312 19 3.93271 18.6635 3.83922 18.1961L3.23922 15.1961Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4141 4C10.1489 4 9.89454 4.10536 9.70701 4.29289L0.707007 13.2929C0.0770423 13.9229 0.52321 15 1.41411 15H94.5857C95.4766 15 95.9228 13.9229 95.2928 13.2929L86.2928 4.29289C86.1053 4.10536 85.8509 4 85.5857 4H10.4141ZM84.9999 5H10.9999L2.9999 13H92.9999L84.9999 5Z",
    fill: "#A4A4A4"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_10278_34830)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 3,
    width: 80,
    height: 8,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5L11 1L2.5 9.5L5 13.5L12 5Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 5L85 1L93.5 9.5L91 13.5L84 5Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 1H85L84 5H12L11 1Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.23922 11.1961C3.11547 10.5773 3.58876 10 4.2198 10H91.7802C92.4112 10 92.8845 10.5773 92.7608 11.1961L92.1608 14.1961C92.0673 14.6635 91.6569 15 91.1802 15H4.8198C4.34312 15 3.93271 14.6635 3.83922 14.1961L3.23922 11.1961Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4141 0C10.1489 0 9.89454 0.105357 9.70701 0.292893L0.707007 9.29289C0.0770423 9.92286 0.52321 11 1.41411 11H94.5857C95.4766 11 95.9228 9.92286 95.2928 9.29289L86.2928 0.292893C86.1053 0.105357 85.8509 0 85.5857 0H10.4141ZM84.9999 1H10.9999L2.9999 9H92.9999L84.9999 1Z",
    fill: "#A4A4A4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10278_34830"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 13,
    fill: "white",
    transform: "translate(0 12)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10278_34830"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 13,
    fill: "white",
    transform: "translate(0 8)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_10278_34830"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 13,
    fill: "white",
    transform: "translate(0 4)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_10278_34830"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrays);
export default __webpack_public_path__ + "static/media/trays.70e4ce7a13a0cf7e6f0ec03544a2c8b4.svg";
export { ForwardRef as ReactComponent };